import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RpReportsComponent } from './rp-reports.component';

const routes: Routes = [{ path: 'reports', component: RpReportsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportsRoutingModule {}
